import { render, staticRenderFns } from "./RedirectToLoginOrOldPeak.vue?vue&type=template&id=26eafa02&scoped=true&"
import script from "./RedirectToLoginOrOldPeak.vue?vue&type=script&lang=ts&"
export * from "./RedirectToLoginOrOldPeak.vue?vue&type=script&lang=ts&"
import style0 from "./RedirectToLoginOrOldPeak.vue?vue&type=style&index=0&id=26eafa02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eafa02",
  null
  
)

export default component.exports